export const labels = {
    all: 'All',
    read: 'Read',
    unread: 'Unread',
} as const;

export type FilterLabel = keyof typeof labels;
